// extracted by mini-css-extract-plugin
module.exports = {"priceUp":"AnimatedPrice_priceUp__DPWbH","price-up":"AnimatedPrice_price-up__p4jVO","priceDown":"AnimatedPrice_priceDown__BgfEw","price-down":"AnimatedPrice_price-down__FGdNQ"};